import {useState} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";


export default function ProjectsEditStatus(props) {
    //console.debug("RTS Break ProjectsEditStatus");

    const [status, setStatus] = useState(props.status);
    const [repoStatus] = useState([{value:0, label:"Planning"}, {value:50, label:"Started"}, {value:100, label:"Complete"}]);


    function valChange(e, val){
        setStatus(val.value);
        props.setStatusFx(val.value);
        props.setFormDirtyFx(1);
    }

 
    return(
        <>
            <Autocomplete
                options={repoStatus}
                renderInput={(params) => <TextField {...params} label="Status" margin='normal' required size="small" />}
                value={repoStatus.find(v => v.value===status)}
                onChange={valChange}
                getOptionLabel={(repoStatus) => repoStatus.label + ' (' + repoStatus.value + ')'}
                renderOption={(props, repoStatus) => (
                    <Box component="li" {...props} key={repoStatus.value}>
                        {repoStatus.label + ' (' + repoStatus.value + ')'}
                    </Box>
                )}
            />
        </>
    );
}
